import { Button } from '@/components/ui/button';
import { FlipWords } from '@/components/ui/flip-words';
import { SparklesCore } from '@/components/ui/sparkles';
import { motion } from 'motion/react';
import { WorldMap } from '../ui/world-map';

const words = ['innovation', 'success', 'growth', 'trust', 'excellence'];

const oviedo = { lat: 30, lng: -6 };
const toronto = { lat: 43, lng: -79 };
const mexicoCity = { lat: 2, lng: -104 };
const buenosAires = { lat: -54, lng: -59 };
const london = { lat: 51, lng: -0 };
const newDelhi = { lat: 28, lng: 77 };
const southAfrica = { lat: -52, lng: 22 };
const sydney = { lat: -55, lng: 157 };

const locations = [
  { start: oviedo, end: toronto },
  { start: oviedo, end: mexicoCity },
  { start: oviedo, end: buenosAires },
  { start: oviedo, end: london },
  { start: oviedo, end: newDelhi },
  { start: oviedo, end: southAfrica },
  { start: oviedo, end: sydney },
];

export default function Intro() {
  return (
    <section className="container mx-auto flex flex-col  min-h-screen mt-40 text-center">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="container flex flex-col items-center justify-center gap-6 text-center"
      >
        <div className="text-8xl tracking-tighter sm:text-[3.75rem] md:text-[4.5rem] lg:text-[6rem] pb-3 px-2 gradient-text-gray">
          <motion.h1 initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.4 }}>
            GoPartner is the new way <br />
            <span className="inline-flex items-center gap-4">
              <span className="whitespace-nowrap">to build</span>
              <span className="w-[300px] inline-block text-left">
                <FlipWords words={words} />
              </span>
            </span>
          </motion.h1>
        </div>
        <div className="absolute">
          <SparklesCore minSize={0.6} maxSize={1.2} particleDensity={15} speed={0.1} particleColor="#C08D02" />
        </div>

        <motion.span
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.5 }}
          className="max-w-[750px] text-center text-lg text-muted-foreground sm:text-xl"
        >
          Create, deploy, and scale Discord bots without writing a single line of code.
        </motion.span>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.6 }}
          className="flex gap-4 z-2"
        >
          <Button className="h-12 px-8 text-lg">Book a free call now</Button>
        </motion.div>
      </motion.div>
      <WorldMap dots={locations} />
    </section>
  );
}
